var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26082 11.6173C8.06882 11.6173 7.87682 11.5443 7.73082 11.3973C6.99282 10.6603 6.58582 9.68025 6.58582 8.63825C6.58582 6.47825 8.34182 4.72125 10.4998 4.72125C11.5378 4.72125 12.5458 5.14025 13.2648 5.87125C13.5548 6.16725 13.5518 6.64125 13.2558 6.93125C12.9608 7.22325 12.4868 7.21825 12.1958 6.92425C11.7568 6.47725 11.1388 6.22125 10.4998 6.22125C9.16882 6.22125 8.08582 7.30525 8.08582 8.63825C8.08582 9.27925 8.33682 9.88325 8.79082 10.3373C9.08382 10.6303 9.08382 11.1043 8.79182 11.3973C8.64482 11.5443 8.45282 11.6173 8.26082 11.6173Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0674 12.4912C10.7124 12.4912 10.3964 12.2372 10.3304 11.8752C10.2564 11.4682 10.5264 11.0772 10.9344 11.0032C11.9144 10.8252 12.6904 10.0472 12.8664 9.06624C12.9404 8.65924 13.3304 8.39124 13.7374 8.46124C14.1454 8.53424 14.4164 8.92424 14.3434 9.33224C14.0564 10.9252 12.7944 12.1892 11.2024 12.4792C11.1574 12.4872 11.1114 12.4912 11.0674 12.4912Z",
    fill: "#BABABA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_107_408",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0.624512H16.5862V14.7226H0.5V0.624512Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_107_408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15438 14.7226C4.99238 14.7226 4.82938 14.6696 4.69138 14.5626C3.00038 13.2346 1.57138 11.2876 0.561378 8.93364C0.479378 8.74364 0.479378 8.52964 0.561378 8.34064C1.58238 5.97664 3.02038 4.01964 4.72038 2.68264C8.18638 -0.0603611 12.8004 -0.0693612 16.3014 2.70264C16.6264 2.95964 16.6814 3.43164 16.4244 3.75664C16.1664 4.07964 15.6964 4.13664 15.3704 3.87864C12.4044 1.53064 8.58338 1.53864 5.64938 3.86064C4.21338 4.99064 2.98038 6.63664 2.07038 8.63864C2.97138 10.6286 4.19338 12.2646 5.61838 13.3826C5.94438 13.6386 6.00038 14.1106 5.74438 14.4356C5.59638 14.6236 5.37638 14.7226 5.15438 14.7226Z",
    fill: "#BABABA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_107_408",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 14,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21753 4.74121H20.5001V16.6894H7.21753V4.74121Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_107_408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5002 16.6894C9.56316 16.6894 8.63116 16.5374 7.73116 16.2384C7.33816 16.1074 7.12516 15.6824 7.25616 15.2894C7.38716 14.8954 7.81016 14.6864 8.20516 14.8144C8.95216 15.0634 9.72416 15.1894 10.5002 15.1894C13.9282 15.1894 17.0612 12.7474 18.9302 8.63642C18.4742 7.63742 17.9432 6.73242 17.3492 5.94242C17.1002 5.61142 17.1662 5.14042 17.4972 4.89142C17.8272 4.64242 18.2982 4.71042 18.5472 5.04042C19.2712 6.00142 19.9072 7.11242 20.4382 8.33842C20.5212 8.52842 20.5212 8.74442 20.4382 8.93342C18.3422 13.7904 14.6272 16.6894 10.5002 16.6894Z",
    fill: "#BABABA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_107_408",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 19,
    height: 18
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86353 0.000427246H19.137V17.2734H1.86353V0.000427246Z",
    fill: "#BABABA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_107_408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61328 17.2734C2.42128 17.2734 2.22928 17.2004 2.08328 17.0534C1.79028 16.7604 1.79028 16.2864 2.08328 15.9934L17.8573 0.219445C18.1503 -0.0735552 18.6243 -0.0735552 18.9173 0.219445C19.2103 0.512445 19.2103 0.987445 18.9173 1.28044L3.14328 17.0534C2.99728 17.2004 2.80528 17.2734 2.61328 17.2734Z",
    fill: "#BABABA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityDisabled);
export default __webpack_public_path__ + "static/media/visibility-disabled.a56b651083a6c4fd3945ff006d7b7da3.svg";
export { ForwardRef as ReactComponent };